import type { SVGProps } from 'react';
const SvgIconComment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M8.074 17.433a2 2 0 0 1 1.828-.257c1.087.385 2.305.606 3.6.606 5.114 0 8.53-3.233 8.53-6.427s-3.416-6.427-8.53-6.427-8.528 3.234-8.528 6.427c0 1.286.508 2.523 1.463 3.583.353.39.525.904.484 1.426a7 7 0 0 1-.463 1.985 10.5 10.5 0 0 0 1.616-.912zm-4.2 1.63q.111-.162.21-.325c.41-.666.8-1.542.877-2.526-1.23-1.37-1.956-3.045-1.956-4.857C3.005 6.74 7.705 3 13.503 3S24 6.74 24 11.355s-4.7 8.356-10.497 8.356a12.8 12.8 0 0 1-4.269-.72c-.488.35-1.283.828-2.227 1.23-.619.265-1.324.506-2.054.646q-.05.01-.098.02c-.18.033-.357.06-.542.077q-.014.002-.028.004a7 7 0 0 1-.628.032.66.66 0 0 1-.607-.398.63.63 0 0 1 .14-.699q.25-.253.463-.542.105-.139.197-.277l.012-.02h.013z"
    />
  </svg>
);
export default SvgIconComment;
